<div class="ds-grid ds-grid--1">
	<div class="ds-example">
		<div class="ds-example__content">
			<eif-resources-manager [showFormatInfo]="true"></eif-resources-manager>
		</div>
	</div>
</div>
